module.exports = __webpack_public_path__ + "img/1253833923.e8f06395.jpg";